"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var _1 = require("./");
var FlightReminderComponent = (function () {
    function FlightReminderComponent() {
        this.buttonClickedEmitter = new core_1.EventEmitter();
    }
    FlightReminderComponent.prototype.ngOnInit = function () {
        if (this.policies && this.policy) {
            throw new TypeError('Please provied only one input for IApiQuoteResponseModel([]) (policies or policy)');
        }
    };
    FlightReminderComponent.prototype.buttonClicked = function (policyNumber) {
        this.buttonClickedEmitter.emit(policyNumber);
    };
    FlightReminderComponent.prototype.checkPolicyForFlightReminder = function (policyFlightOverride) {
        if (policyFlightOverride.doesPackageHaveConditionalFlights && policyFlightOverride.flightCount === 0 && policyFlightOverride.futureFlightsExpected === true) {
            return true;
        }
        return false;
    };
    FlightReminderComponent.prototype.checkPoliciesForFlightReminder = function (policyFlightOverrides) {
        var conditionInFunctionNameMet = false;
        for (var i = 0; i <= policyFlightOverrides.length - 1; i++) {
            if (this.checkPolicyForFlightReminder(policyFlightOverrides[i]) === true) {
                return true;
            }
        }
        return false;
    };
    Object.defineProperty(FlightReminderComponent.prototype, "showFlightReminder", {
        get: function () {
            var show = false;
            if (this.policies) {
                show = this.checkPoliciesForFlightReminder(this.policies);
            }
            else if (this.policy) {
                show = this.checkPolicyForFlightReminder(this.policy);
            }
            return show;
        },
        enumerable: true,
        configurable: true
    });
    return FlightReminderComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], FlightReminderComponent.prototype, "policies", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", _1.PolicyFlightOverride)
], FlightReminderComponent.prototype, "policy", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], FlightReminderComponent.prototype, "buttonText", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], FlightReminderComponent.prototype, "message", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], FlightReminderComponent.prototype, "messageHeading", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], FlightReminderComponent.prototype, "buttonClickedEmitter", void 0);
FlightReminderComponent = __decorate([
    core_1.Component({
        selector: 'flight-reminder',
        template: "<div class=\"flight-reminder\" *ngIf=\"showFlightReminder\">     <p class=\"flight-reminder-text\">         <span class=\"bold-text\">{{messageHeading}}</span>         <span>{{message}}</span>     </p>     <flight-reminder-button \t\t[policies]=\"policies\" \t\t[policy]=\"policy\" \t\t[buttonText]=\"buttonText\" \t\t(buttonClickedEmitter)=\"buttonClicked($event)\">     </flight-reminder-button> </div>"
    }),
    __metadata("design:paramtypes", [])
], FlightReminderComponent);
exports.FlightReminderComponent = FlightReminderComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/flight-reminder/flight-reminder.component.js